import { Searchbar } from "../../common/components/general/Searchbar";
import { CollectionItem } from "./components/CollectionItem";
import { mapCollection, useGetCollectionsQuery } from "./CollectionsSlice";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { JSX, useEffect } from "react";
import { CollectionInterface } from "../../common/interfaces/collections/CollectionInterface";
import { useGetUserInfoQuery } from "../../app/rootReducer";
import { CollectionItemSkeleton } from "./components/CollectionItemSkeleton";
import { useStringTranslation } from "../../common/hooks/useStringTranslation";

const CollectionsPageContainer = (): JSX.Element => {
    const dispatch = useAppDispatch();
    const userData = useGetUserInfoQuery();
    const { activeLanguage } = userData?.data || { activeLanguage: null };
    const { t, isLoading: isLoadingTranslations } = useStringTranslation();
    const { data, isLoading: isLoadingCollections } = useGetCollectionsQuery();

    const translationsLoaded = !isLoadingTranslations && !!activeLanguage;

    useEffect(() => {
        if (data) {
            dispatch(mapCollection(data));
        }
    }, [data, dispatch]);

    const { collections } = useAppSelector((state) => state.collections);

    return (
        <>
            <div className="p-collections">
                <div className="p-collections__header">
                    <div className="c-breadcrumbs">
                        {translationsLoaded ? (
                            <>
                                <span>{t("collections")}</span>
                                <div className="c-breadcrumbs__arrow">
                                    <img
                                        src="/images/arrow-black.svg"
                                        alt="arrow"
                                    />
                                </div>
                                <span>{t("overview")}</span>
                            </>
                        ) : (
                            <>
                                <span className="skeleton skeleton-name"></span>
                                <div className="c-breadcrumbs__arrow">
                                    <img
                                        src="/images/arrow-black.svg"
                                        alt="arrow"
                                    />
                                </div>
                                <span className="skeleton skeleton-name"></span>
                            </>
                        )}
                    </div>
                    <Searchbar />
                </div>

                <div className="p-collections__content">
                    <div className="p-collections__content__header">
                        {translationsLoaded ? (
                            <h2>
                                {collections.length}{" "}
                                {t("collections").toLowerCase()}
                            </h2>
                        ) : (
                            <h2 className="skeleton skeleton-title-large" />
                        )}
                    </div>

                    {!isLoadingCollections ? (
                        <>
                            {collections.length > 0 && (
                                <div className="p-collections__content__collections">
                                    {collections.map(
                                        (
                                            collection: CollectionInterface,
                                            collectionIndex: number,
                                        ) => (
                                            <CollectionItem
                                                key={collectionIndex}
                                                collection={collection}
                                            />
                                        ),
                                    )}
                                </div>
                            )}
                        </>
                    ) : (
                        <CollectionItemSkeleton />
                    )}
                </div>
            </div>
        </>
    );
};
export default CollectionsPageContainer;
